const getCombinedArtWallProducts = (artWallProducts) => {
  const prints = artWallProducts?.filter(({categories}) => !categories.map(category => category.slug).includes('frames'))
  const frames = artWallProducts?.filter(({categories}) => categories.map(category => category.slug).includes('frames'))

  const combined = prints.map((print) => [print, frames.find((frame) => print.uuid === frame.belongsTo)].filter((item) => item !== undefined))

  return combined
}

export default getCombinedArtWallProducts